import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { ReferrerService } from './core/tracking/referrer.service';
import { init } from 'aos';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly referrerService: ReferrerService,
    private readonly swUpdate: SwUpdate,
    viewportScroller: ViewportScroller,
  ) {
    // Preserva el scrollOffset:[0,64] que RouterModule.forRoot() aplicaba antes de la migración
    // a bootstrapApplication() — withInMemoryScrolling() no tiene un equivalente para esa opción.
    viewportScroller.setOffset([0, 64]);
  }

  ngOnInit(): void {
    // Primero calculamos el referrer (getUrl + saveUrl) y luego capturamos
    // el source, así captureSource ya puede resolverlo desde el referrer y
    // persistirlo en sessionStorage desde el arranque.
    this.getUrl();
    this.saveUrl();
    this.referrerService.captureSource();
    this.loadAOS();
    this.checkForUpdates();
  }

  loadAOS(): void {
    init({
      once: true,
    });
  }

  getUrl(): void {
    const referrer = document.referrer;
    if (referrer === '') {
      const search = document.location.search;
      if (search === '') {
        this.referrerService.setReferrerUrl(referrer);
      } else {
        this.referrerService.setReferrerUrl(document.location.href);
      }
    } else {
      this.referrerService.setReferrerUrl(this.mergeLandingParams(referrer));
    }
  }

  // Cuando SÍ hay un referrer externo, le anexamos los query params de la
  // landing URL actual (utm_*, gclid, click_id, etc.) que el referrer no
  // traiga. Es necesario porque en clics de Google Ads el navegador suele
  // reportar un Referer "limpio" (ej. https://www.google.com/, sin gclid
  // ni utm_source) mientras esos parámetros solo viven en la URL de
  // aterrizaje — sin este merge, classifyReferrer() no encuentra la señal
  // de pago y clasifica el lead como "Google Organic" en vez de
  // "Google Paid". Si el referrer ya trae un param con la misma key, se
  // conserva el valor del referrer (el referrer manda sobre la landing).
  mergeLandingParams(referrer: string): string {
    try {
      const referrerUrlObj = new URL(referrer);
      const landingUrlObj = new URL(document.location.href);
      landingUrlObj.searchParams.forEach((value, key) => {
        if (!referrerUrlObj.searchParams.has(key)) {
          referrerUrlObj.searchParams.set(key, value);
        }
      });
      return referrerUrlObj.toString();
    } catch (e) {
      return referrer;
    }
  }

  saveUrl(): void {
    this.referrerService.saveReferrer();
  }

  checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.swUpdate.activateUpdate().then(() => {
            globalThis.location.reload();
          });
        }
      });
    }
  }
}
